import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { setReferralCookie } from '../../lib/referralCookie.js';

// /ref/:code — stash the code in a cookie and redirect to /signup. The signup
// form reads the cookie at mount and forwards the code with the POST body.
// Server-side, the code is looked up against User.referralCode (Beehiiv-issued
// codes mirrored locally) and forwarded to Beehiiv on subscription create.
export default function RefLanding() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) setReferralCookie(code);
    navigate('/signup', { replace: true });
  }, [code, navigate]);

  return null;
}
